module.exports = __webpack_public_path__ + "ipetbooking/admin/img/chart-bar.d24214f9.svg";